<template>
    <div>
        <v-app>
            <v-card elevation="2" outlined class="p-3">
                <v-card-title class="justify-content-between">
                    <div>
                        <span>سفارش های من</span>
                    </div>

                    <div>
                        <v-btn class="btn-search"
                               @click="tableProps = tablePropsDefault; getSites()">
                            <v-icon>mdi-refresh</v-icon>
                            بارگذاری مجدد
                        </v-btn>
                    </div>
                </v-card-title>
                <v-divider/>

                <div class="row">

                    <div class="col-md-12 p-5">
                        <!--                            <v-alert v-if="userInfo.meta.total==0">برای ثبت سفارش به تب ثبت سفارش جدید مراجعه کنید</v-alert>-->
                        <template>
                            <v-row justify="center">
                                <custom-popup v-model="showDialog"
                                              max-width="900"
                                              hide-overlay
                                              :cons="cons"
                                              transition="dialog-bottom-transition"
                                              hide-confirm>
                                    <v-card>
                                        <pay-page v-if="showDialog" :modal="()=>{this.showDialog=false}"
                                                  :reqAgain="()=>{this.reloadTable(url)}" :archives="infos"></pay-page>
                                    </v-card>

                                </custom-popup>
                            </v-row>
                        </template>


                        <template>
                            <v-row justify="center">

                                <custom-popup v-model="myDia"
                                              max-width="900"
                                              hide-overlay
                                              :cons="cons"
                                              transition="dialog-bottom-transition"
                                              hide-confirm
                                >
                                    <v-card class="px-5">
                                        <visit-infos :admin="false" v-if="$route.name==='visit.index' && myDia"
                                                     url="form/graphic/visitCards" :modal="()=>{this.showDialog=false}"
                                                     :reqAgain="()=>{this.reloadTable(url)}" :id="myID"></visit-infos>

                                        <tracet-informations v-if="$route.name==='tracet.index' && myDia" :admin="false"
                                                             url="form/graphic/tracet"
                                                             :modal="()=>{this.showDialog=false}"
                                                             :reqAgain="()=>{this.reloadTable(url)}"
                                                             :id="myID"></tracet-informations>

                                        <set-informations v-if="$route.name==='officeSet.index' && myDia" :admin="false"
                                                          url="form/graphic/officeSet"
                                                          :modal="()=>{this.showDialog=false}"
                                                          :reqAgain="()=>{this.reloadTable(url)}"
                                                          :id="myID"></set-informations>

                                        <officeinfos v-if="$route.name==='headerForm.index' && myDia" :admin="false"
                                                     url="form/graphic/headers"
                                                     :modal="()=>{this.showDialog=false}"
                                                     :reqAgain="()=>{this.reloadTable(url)}" :id="myID"></officeinfos>


                                        <banner-information v-if="$route.name==='banner.index' && myDia" :admin="false"
                                                            url="form/graphic/banner"
                                                            :modal="()=>{this.showDialog=false}"
                                                            :reqAgain="()=>{this.reloadTable(url)}"
                                                            :id="myID"></banner-information>


                                        <poster-informations v-if="$route.name==='poster.index' && myDia" :admin="false"
                                                            url="form/graphic/poster"
                                                            :modal="()=>{this.showDialog=false}"
                                                            :reqAgain="()=>{this.reloadTable(url)}"
                                                            :id="myID"></poster-informations>

                                        <bro-informations v-if="$route.name==='brochur.index' && myDia" :admin="false"
                                                             url="form/graphic/brochure"
                                                             :modal="()=>{this.showDialog=false}"
                                                             :reqAgain="()=>{this.reloadTable(url)}"
                                                             :id="myID"></bro-informations>


                                        <informations :show-list="true" v-if="$route.name==='logo.index' && myDia" :admin="false"
                                                      :modal="()=>{this.myDia=false}"
                                                      :reqAgain="()=>{this.reloadTable(url)}" :id="myID"></informations>
                                    </v-card>

                                </custom-popup>
                            </v-row>
                        </template>

                        <terminal-table class="col-12" :currentPage="userInfo.current_page"
                                        :perPage="userInfo.per_page" v-if="isMobile" :getData="getSites"
                                        :pageCount="userInfo.last_page"
                                        :options="tableProps" :datas="userInfo" :headers="columns"></terminal-table>


                        <data-table v-else :data="userInfo" :columns="columns"
                                    :translate="translate"
                                    :per-page="[10, 25, 50, 100]"
                                    @on-table-props-changed="reloadTable">
                            <div slot="filters" slot-scope="{ tableFilters, perPage }">
                                <div class="row mb-2">
                                    <div class="col-md-4">
                                        <select class="form-control pr-3"
                                                v-model="tableFilters.length">
                                            <option :key="page" v-for="page in perPage">
                                                {{ page }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-4">
                                    </div>

                                    <div class="col-md-4 ">
                                        <v-text-field outlined dense label="جست و جو"
                                                      class="pl-3"
                                                      @change="(i) => (tableFilters.search = i)">

                                        </v-text-field>
                                    </div>
                                </div>
                            </div>
                        </data-table>

                    </div>
                </div>
            </v-card>
        </v-app>
    </div>
</template>

<script>
import loginRollback from "@/Utilities/LoginRollback";
import jwtService from "@/core/services/jwt.service";
import actionButton from '@/view/content/button'
import siteStatusButton from "@/view/pages/site/siteStatusButton";
import PayPage from "./payPage";
import Informations from "../admin/informations";
import Officeinfos from "@/view/pages/site/office/officeInfos";
import VisitInfos from "@/view/pages/site/visitInfos";
import TracetInfos from "@/view/pages/site/tracet/tracetInfo";
import TracetInformations from "@/view/pages/site/tracet/tracetInfo";
import SetInformations from "@/view/pages/components/setInformation";
import button from "@/view/content/button";
import BannerInformation from "@/view/pages/site/banner/components/bannerInformation";
import CustomPopup from "@/core/plugins/TitleRibbon/plugins/popup/customPopup";
import PosterInformations from "@/view/pages/site/poster/posterInformations";
import BroInformations from "@/view/pages/site/brochur/broInformations";

export default {
    name: 'orderList',
    components: {
        BroInformations,
        PosterInformations,
        CustomPopup,
        BannerInformation,
        SetInformations, TracetInformations, TracetInfos, VisitInfos, Officeinfos, Informations, PayPage
    },
    props: {
        url: '',
    },
    data() {
        return {
            dialogPayment: false,
            showDialog: false,
            myID: '',
            payDialogInfo: {},
            payableTransaction: null,
            selectedRows: [],
            paymentLoading: false,
            errors: [],
            loading: false,
            errorMsg: '',
            infos: {},
            userWallet: [],
            dialogInfo: null,
            tab: null,
            translate: {
                nextButton: 'بعدی',
                previousButton: 'قبلی',
                rowsPerPageText: 'تعداد در صفحه',
                noDataText: 'داده ای برای نمایش وجود ندارد',
                placeholderSearch: 'جستجو',
            },
            userInfo: {},
            tableProps: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
                page: 1,
            },
            tablePropsDefault: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
            },
            columns: [
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.userInfo.meta.current_page - 1;
                        row = row * this.userInfo.meta.per_page;
                        return row + val.row + 1;
                    },
                },
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    colStyle: 'width: 100px;'
                },
                {
                    label: 'نام مجموعه',
                    name: 'organizationName',
                    orderable: true,
                },
                {
                    label: 'نام برند',
                    name: 'brandName',
                    orderable: true,
                },
                {
                    label: 'شعار برند',
                    name: 'brandSlogan',
                    searchable: true,
                    // transform: (value, data) => {
                    //   return value.data.location ? `${value.data.location[0]} , ${value.data.location[1]}` : 'ندارد'
                    // }
                },

                {
                    label: 'زمان تحویل',
                    name: 'deliveryTime',
                    searchable: true,
                    orderable: true,
                    transform: (value, data) => {
                        return this.jalalian(value.data.deliveryTime)
                    }
                },
                {
                    name: 'status',
                    primary: true,
                    label: 'وضعیت',
                    transform(val) {
                        let text = val.data.status;
                        let color = 'light'

                        switch (val.data.status) {
                            case "pending":
                                text = 'در انتظار تایید';
                                color = 'warning'
                                break;

                            case "accept":
                                text = 'در انتظار پرداخت';
                                color = 'info'
                                break

                            case "reject":
                                text = 'رد شده';
                                color = 'danger'
                                break

                            case "disable":
                                text = 'مسدود';
                                color = 'light'
                                break

                            case "paid":
                                text = 'پرداخت شده';
                                color = 'success'
                                break
                        }

                        return `<span class="badge badge-${color}">${text}</span>`;
                    },
                    event: 'action',
                },

                {
                    label: 'مدیریت',
                    name: 'action',
                    component: button,
                    handler: this.actions,
                    event: 'action',
                    permission_prefix: 'user_',
                    meta: {
                        buttons: [
                            {
                                name: "showAll",
                                label: "مشاهده سفارش",
                                icon: "eye",
                                class: "btn-outline-warning",
                                type: 'edit',
                                action: this.actions,
                                condition: () => {
                                    return true;
                                }
                            },
                            {
                                name: "Pay",
                                label: "پرداخت اقساط",
                                icon: "dollar-sign",
                                type: 'show',
                                class: "btn-outline-info",
                                action: this.actions,
                                condition: this.buttonsCondition
                            },

                        ]
                    }
                },
            ],
            statusBadge: '',
            userValid: true,
            myDia: false,
            cons:{
                title:'مشاهده سفارش'
            },
            isRejected: false,
            isPending: false,
            userInfoGot: false
        }
    },
    created() {
        this.getSites(this.url)
    },
    mounted() {
        this.getSites(this.url);
    },
    methods: {
        buttonsCondition(status) {
            return [
                "pending",
                "reject"
            ].indexOf(status) <= -1;
        },

        paymentDialog(data) {
            this.payDialogInfo = data
            this.dialogPayment = true
        },
        getUserInfo() {
            this.userInfoGot = true;
            this.$modal.showLoading();
            this.requestApiGet('userInfo')
                .then(res => {
                    this.$modal.hideLoading();
                    let response = res.data.data
                    if (response.status == 'accept') {
                        this.userValid = true
                        this.statusBadge = 'accept'
                    } else if (response.status == 'reject') {
                        this.isRejected = true
                        this.userValid = false
                        this.statusBadge = 'reject'
                        let _this = this;
                        this.$modal.error('اطلاعات تکمیلی نیاز به ویرایش دارد', 'اطلاعات شما دارای مشکل میباشد',
                            undefined,
                            {},
                            [
                                {
                                    text: "رفتن به صفحه تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    } else if (response.status == 'pending') {
                        this.isPending = true
                        this.userValid = false
                        this.statusBadge = 'pending'
                        this.$modal.warning('در انتظار تایید اطلاعات',
                            'در مرحله در انتظار تایید توسط پشتیبانی شما قادر به ثبت بیلبورد نمیباشید.')
                    } else {
                        this.userValid = false
                        this.statusBadge = ''
                        let _this = this;
                        this.$modal.info('اطلاعات خود را تکمیل کنید',
                            'تا زمانی که اطلاعات خود را تکمیل نکنید قادر به ثبت بیلبورد نمیباشید.',

                            undefined,
                            {},
                            [
                                {
                                    text: "تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    }
                })
                .catch(res => {
                    this.$modal.hideLoading();
                })
        },
        getStatusBadge(status) {
            let text = status;
            let color = 'light'

            switch (status) {
                case "pending":
                    text = 'در انتظار تایید';
                    color = 'warning'
                    break;

                case "accept":
                    text = 'منتظر پرداخت';
                    color = 'info'
                    break

                case "reject":
                    text = 'رد شده';
                    color = 'danger'
                    break

                case "disable":
                    text = 'مسدود';
                    color = 'light'
                    break
            }

            return `<span class="badge badge-${color}">${text}</span>`;
        },
        selectAll(c) {
            window.Vue.$emit("selectedAllCheckbox", c);
        },
        change(data, checked) {
            if (checked) {
                this.selectedRows.push(data.id);
            } else {
                let index = this.selectedRows.indexOf(data.id)
                this.selectedRows = [
                    ...this.selectedRows.slice(0, index),
                    ...this.selectedRows.slice(index + 1, this.selectedRows.length)
                ]

            }
            window.document.querySelector("#select_all").checked = this.selectedRows.length == this.userInfo.data.length

        },
        getSites(url = this.url, params = this.tableProps) {
            this.$modal.showLoading();
            this.requestApiGet(url, params).then(response => {
                this.userInfo = response.data;
            }).finally(() => {
                this.$modal.hideLoading();
            })
        },
        reloadTable(params) {
            this.getSites(this.url, params)
        },
        actions(data, type) {
            this[type](data)
        },
        edit(data) {
            this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
        },
        Pay(data) {
            this.infos = data.payments;
            this.showDialog = true;
        },
        information(data) {
            this.$router.push({name: 'admin.users.information', params: {id: data.id}})
        },
        showAll(data) {
            this.myID = data.id
            this.myDia = true;
        },
    },
    computed: {
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getSites(this.url);
                    return true
                case 'sm':
                    this.getSites(this.url);
                    return true
                case 'md':
                    this.getSites(this.url);
                    return false
                case 'lg':
                    this.getSites(this.url);
                    return false
                case 'xl':
                    this.getSites(this.url);
                    return false
            }
        },
    },

}
</script>

<style scoped>

</style>